module.exports = __webpack_public_path__ + "static/templates/bulk-upload-th.1X7nkf5.xlsx";